<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :item-class="rowClass"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template #[`item.busena`]="{ item }">
        <el-busena :busena="item.busena" />
      </template>
      <template #[`body.append`]>
        <tr>
          <td colspan="5" class="text-end"><strong>Iš viso:</strong></td>
          <td class="text-center">{{ visoVerte }}</td>
        </tr>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../../mixins/userRole'
import math from '../../../mixins/math'

export default {
  name: 'HipotekaPaslaugos',
  mixins: [math, userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      paslaugos: [],
      itemsPerPageOptions: [5, 10, 50, -1],
      pageSize: 5,
    }
  },
  computed: {
    ...mapGetters(['objektasID']),
    headers() {
      return [
        {
          text: 'Registras',
          align: 'start',
          value: 'uzs_registras',
        },
        {
          text: 'Užsakymo Nr.',
          align: 'start',
          value: 'uzsakymo_nr',
        },
        {
          text: 'Data',
          align: 'start',
          value: 'data',
        },
        {
          text: 'Registro informacija',
          align: 'start',
          value: 'pavadinimas',
        },
        {
          text: 'Paslaugos gavėjas',
          align: 'start',
          value: 'paslaugos_gavejas',
          hide: !this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
          ]),
        },
        {
          text: 'Būsena',
          align: 'center',
          value: 'busena',
        },
        {
          text: 'Kaina, Eur',
          align: 'center',
          value: 'sumaFormat',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paslaugos.map(item => {
        item.sumaFormat = this.moneyformat(item.suma)
        return item
      })
    },
    visoVerte() {
      return this.moneyformat(
        this.paslaugos
          .map(item => (item.suma > 0 && !item.deleted ? item.suma : 0))
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue
          }, 0)
      )
    },
    hideFooter() {
      return this.itemsList.length <= 5
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/paslaugos`)
        .then(res => {
          this.paslaugos = res.data.paslaugos
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    rowClass(item) {
      if (item.atsakymas) {
        return `paslaugos-positive`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.visoRow td {
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
